<div class="changes-container">
  <div class="change-card">
    <span class="change-label" i18n>Previous</span>
    <ng-container *ngIf="previousChanges.length">
      <div
        *ngFor="let change of previousChanges; trackBy: trackByFn"
        class="contact-change"
        [class.previous-contact]="change.changeType === EmployerContactSubmissionChangeTypeEnum.Previous">
        {{ change.contactName }}
      </div>
    </ng-container>
    <ng-container *ngIf="!previousChanges.length">
      <div class="no-changes" i18n>Not Applicable</div>
    </ng-container>
  </div>
  <div class="change-card">
    <span class="change-label" i18n>New</span>
    <ng-container *ngIf="hasChanges">
      <div
        *ngFor="let change of newChanges; trackBy: trackByFn"
        class="contact-change"
        [class.new-contact]="change.changeType === EmployerContactSubmissionChangeTypeEnum.New">
        {{ change.contactName }}
      </div>
    </ng-container>
    <ng-container *ngIf="!hasChanges">
      <div class="no-changes" i18n>No Changes</div>
    </ng-container>
  </div>
</div>
